
define('template!webshopQuotationsListView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (items.length === 0 && !loading) { ;
__p += '\n<div class="empty">' +
((__t = ( _.i18n('webshop.quotations.none', null, 'No quotation') )) == null ? '' : __t) +
'</div>\n';
 } ;
__p += '\n';
 _.each(items, function (q) { ;
__p += '\n<div class="quotation ';
 if (q.id === selectedId) { ;
__p += 'selected';
 } ;
__p += '" data-id="' +
((__t = ( q.id )) == null ? '' : __t) +
'">\n    <div class="line">\n        <span class="product">' +
__e( q.productName || q.productCode ) +
'</span>\n        <span class="price">' +
((__t = ( q.total )) == null ? '' : __t) +
'</span>\n    </div>\n    <div class="line infos">\n        <span class="customer ';
 if (!q.customer) { ;
__p += 'anonymous';
 } ;
__p += '">' +
__e( q.customer || _.i18n('webshop.quotations.anonymous', null, 'Anonymous visitor') ) +
'</span>\n        <span class="qty">';
 if (q.quantity) { ;
__p +=
((__t = ( q.quantity )) == null ? '' : __t) +
' ' +
((__t = ( _.i18n('common.pcs', null, 'pcs') )) == null ? '' : __t);
 } ;
__p += '</span>\n    </div>\n    <div class="line infos">\n        <span class="date"><b class="reference">' +
__e( q.reference ) +
'</b> · ' +
((__t = ( q.date )) == null ? '' : __t) +
'</span>\n        <span class="site">' +
__e( q.site ) +
'</span>\n    </div>\n</div>\n';
 }); ;
__p += '\n';
 if (loading) { ;
__p += '\n<div class="loading">' +
((__t = ( _.i18n('common.loading', null, 'Loading...') )) == null ? '' : __t) +
'</div>\n';
 } else if (items.length < total) { ;
__p += '\n<div class="more">' +
((__t = ( _.i18n('webshop.quotations.more', null, 'Show more') )) == null ? '' : __t) +
' (' +
((__t = ( total - items.length )) == null ? '' : __t) +
')</div>\n';
 } ;
__p += '\n';

}
return __p
};});

